import React, { useEffect } from 'react'
import { RouteComponentProps } from '@reach/router'
import { PanelContent } from '../../../components/panel-content'
import { Button } from '../../../components/button'
import { useStateValue } from '../../../components/state'
import { MapFact } from '../../../components/map-fact'
import { useDelayedBoolean } from '../../../hooks/use-delayed-boolean'
import { Video } from '../../../components/video'
import { TextLink } from '../../../components/text-link'

export const Desalination: React.FC<RouteComponentProps> = () => {
  const [, dispatch] = useStateValue()

  // Filter map pins to desalination
  useEffect(() => {
    dispatch({
      type: 'setActiveMarkerType',
      payload: { activeMarkerType: 'desalination' }
    })
  }, [dispatch])

  const factVisible = useDelayedBoolean({ delay: 500 })

  return (
    <PanelContent>
      <h1>Desalination</h1>
      <p>
        <TextLink href='https://www.watercorporation.com.au/Our-water/Desalination'>
          Desalination
        </TextLink>{' '}
        (or desal) involves removing salt from seawater to produce fresh water.
        We have 2 desal plants in WA: the{' '}
        <TextLink href='https://www.watercorporation.com.au/Our-water/Desalination/Perth-Seawater-Desalination-Plant'>
          Perth Seawater Desalination Plant
        </TextLink>{' '}
        and the{' '}
        <TextLink href='https://www.watercorporation.com.au/Our-water/Desalination/Southern-Seawater-Desalination-Plant'>
          Southern Seawater Desalination Plant
        </TextLink>
        . Together they supply nearly half of Perth's water needs!
      </p>
      <p>
        Desal is a reliable water source because it doesn’t depend on rainfall.
        As we get less rain as a result of climate change, we’ll need to rely on
        desal more.
      </p>
      <Video videoId='JoF13nwgUvA' />
      <MapFact
        aboveValue='Our desal plants use a process called reverse osmosis to filter out all the salt and impurities in seawater'
        visible={factVisible}
        position='top-right'
      />
      <Button href='/why'>Why does my water come from desalination?</Button>
    </PanelContent>
  )
}
